const DepositTypeConstant = {
  STORE: 'STORE',
  SWIKLY: 'SWIKLY'
}

export default DepositTypeConstant
